import { render, staticRenderFns } from "./piaoju.vue?vue&type=template&id=1ca09d2b&"
import script from "./piaoju.vue?vue&type=script&lang=js&"
export * from "./piaoju.vue?vue&type=script&lang=js&"
import style0 from "./piaoju.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports